// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ti-2";
export var container = "_ti-4";
export var dismissButton = "_ti-3";
export var hasPaddingBottom = "_ti-6";
export var last = "_ti-e";
export var scrollbarThumb = "_ti-c";
export var scrollbarTrack = "_ti-b";
export var selected = "_ti-9";
export var spin = "_ti-1";
export var spinning = "_ti-0";
export var suggestionItem = "_ti-d";
export var suggestionsPanel = "_ti-5";
export var tonePill = "_ti-8";
export var tonesContainer = "_ti-7";
export var unselected = "_ti-a";